/*
    DATI DEL SITO PER MOTORI DI RICERCA E ANTEPRIME SOCIAL: è l'unico punto da modificare.
    Li usa SEOHead (src/components/SEOHead.js) per titolo, descrizione, anteprime social, canonical e
    dati strutturati (JSON-LD); il prerender (npm run build:seo) li scrive nell'HTML statico della home.
    L'indirizzo serve anche ai QR della partita (Home.js, Game.js).

    Restano fuori perché sono file statici:
        public/manifest.json              -> nome dell'app installata sul telefono (name, short_name)
        public/robots.txt, sitemap.xml    -> indirizzo del sito
    I testi visibili della landing sono contenuto della pagina e stanno in Landing.js.
*/

const SITE = {
    url: "https://intesavincente.tommasofaraci.it/",
    //nome del sito nei risultati di Google (markup WebSite) e nelle anteprime social
    name: "L'Intesa Vincente Online",
    //nome alternativo del sito
    alternateName: "Intesa Vincente Online",
    author: "Tommaso Faraci",
    //titolo della scheda e del risultato di ricerca: oltre i 60 caratteri circa Google lo taglia
    title: "L'Intesa Vincente Online – Gioco di Reazione a Catena gratis",
    //testo sotto il titolo nei risultati e nelle anteprime: oltre i 155 caratteri circa Google lo taglia
    description: "Quanto vi capite davvero? Gioca gratis all'Intesa Vincente Online con gli amici, come in TV: crea le squadre e aggiungi le tue parole. Gioco non ufficiale.",
    //immagine delle anteprime social (in public/)
    image: "og-image.jpg",
    imageWidth: 1200,
    imageHeight: 628,
    imageAlt: "Logo de L'Intesa Vincente Online",
};

export default SITE;
